export const protectRouteAnnouncerFromTranslation = (): (() => void) => {
    const protect = (host: Element): void => {
        host.setAttribute("translate", "no");
        host.classList.add("notranslate");

        const announcer = host.shadowRoot?.querySelector("#__next-route-announcer__");
        announcer?.setAttribute("translate", "no");
        announcer?.classList.add("notranslate");
    };

    document.querySelectorAll("next-route-announcer").forEach(protect);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof Element && node.matches("next-route-announcer")) {
                    protect(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true });

    return () => observer.disconnect();
};
